// Product size defaults; cart checkout proceeds without confirmation.
let initialised = false;
const choicesMade = new Set();
const host = () => document.querySelector('[data-ev-size-host]');
const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
const productPicker = () => document.querySelector('.product-details variant-picker[data-template-product-match="true"]');
const preferredSize = picker => {
  const inputs = Array.from(picker.querySelectorAll('input[type="radio"]'));
  const normalize = value => ({ MEDIUM: 'M', LARGE: 'L', SMALL: 'S', 'EXTRA LARGE': 'XL', 'X-LARGE': 'XL' }[value.trim().toUpperCase()] || value.trim().toUpperCase());
  const order = inputs.some(input => ['30', '32', '34', '36'].includes(normalize(input.value))) ? ['32', '34', '30', '36'] : ['M', 'L', 'S', 'XL'];
  return order.map(size => inputs.find(input => normalize(input.value) === size && input.dataset.optionAvailable === 'true')).find(Boolean);
};
const explicitURL = () => { const url = new URL(location.href); return url.searchParams.has('variant') || url.searchParams.has('option_values'); };
function requiresChoice(picker) {
  if (!picker || picker.querySelectorAll('fieldset').length !== 1 || choicesMade.has(picker.dataset.productId)) return false;
  return !preferredSize(picker);
}
function showSizePrompt(picker) {
  let notice = document.querySelector('.ev-product-size-notice');
  if (!notice) { notice = document.createElement('p'); notice.className = 'ev-product-size-notice'; notice.setAttribute('role', 'alert'); picker.after(notice); }
  notice.textContent = host().dataset.sizePrompt;
  picker.querySelector('input:not([aria-disabled="true"])')?.focus();
  picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
}
async function initialiseDefaults() {
  if (initialised) return;
  initialised = true;
  await customElements.whenDefined('variant-picker');
  const picker = productPicker();
  if (!picker || picker.querySelectorAll('fieldset').length !== 1) return;
  if (explicitURL()) { choicesMade.add(picker.dataset.productId); return; }
  if (choicesMade.has(picker.dataset.productId)) return;
  const preferred = preferredSize(picker);
  if (!preferred) return;
  if (!preferred.checked) {
    preferred.checked = true;
    preferred.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

document.addEventListener('change', event => {
 const picker = event.target.closest?.('variant-picker');
 if (picker && event.isTrusted) { choicesMade.add(picker.dataset.productId); document.querySelector('.ev-product-size-notice')?.remove(); }
});
document.addEventListener('click', event => {
 const sizeInput = event.target.closest('variant-picker input[type="radio"]');
 if (sizeInput && event.isTrusted) { choicesMade.add(sizeInput.closest('variant-picker').dataset.productId); document.querySelector('.ev-product-size-notice')?.remove(); }
 const add = event.target.closest('button[name="add"],add-to-cart-component button');
 if (add?.closest('.product-details') && requiresChoice(productPicker())) { stop(event); showSizePrompt(productPicker()); }
}, true);
document.addEventListener('submit', event => {
 if (event.target.closest('.product-details') && event.target.matches('form[data-type="add-to-cart-form"]') && requiresChoice(productPicker())) { stop(event); showSizePrompt(productPicker()); }
}, true);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseDefaults, { once: true });
else initialiseDefaults();
